import React, {useEffect, useRef, useState} from 'react';
import {
  View,
  Platform,
  ActivityIndicator,
} from 'react-native';

import * as Location from 'expo-location';

let Maps;
let PlacesMap;

if (Platform.OS !== 'web') {
  Maps = require('react-native-maps');

  // eslint-disable-next-line react/display-name
  PlacesMap = ({cards}) => {
    const mapViewRef = useRef();

    const [showUserLocation, setShowUserLocation] = useState(false);

    useEffect(() => {
      const checkLocationPermission = async () => {
        const locationPerm = await Location.getForegroundPermissionsAsync();

        if (locationPerm.granted) {
          setShowUserLocation(true);
        }
      };

      checkLocationPermission();
    }, []);

    return (
      <View
        style={{
          marginVertical: 6,
          height: 200,
          borderRadius: 20,
          overflow: 'hidden',
        }}
      >
        <Maps.default
          ref={mapViewRef}
          provider={Maps.PROVIDER_GOOGLE}
          style={{
            width: '100%',
            height: '100%',
          }}
          showsUserLocation={showUserLocation}
          scrollEnabled={false}
          onMapReady={() => {
            setTimeout(() => mapViewRef.current && mapViewRef.current.fitToSuppliedMarkers(
              cards.map(({id}) => id.toString()),
              {
                animated: false,
                edgePadding: Platform.OS === 'ios'
                  ? {
                    top: 40,
                    right: 15,
                    bottom: 15,
                    left: 15,
                  }
                  : {
                    top: 150,
                    right: 50,
                    bottom: 50,
                    left: 50,
                  },
              }
            ), 0);
          }}
        >
          {cards.map(card => card.card_type === 'place' && (
            <Maps.Marker
              key={card.id}
              identifier={card.id.toString()}
              coordinate={{latitude: card.latitude, longitude: card.longitude}}
              title={card.title}
            />
          ))}
        </Maps.default>
      </View>
    );
  };
} else {
  Maps = require('@react-google-maps/api');

  // eslint-disable-next-line react/display-name
  PlacesMap = ({cards}) => {
    const {isLoaded, loadError} = Maps.useLoadScript({
      googleMapsApiKey: 'AIzaSyC6fgqbEA1FjrlKFs1Xz85Fps8tm_enBvI',
    });

    const renderMap = () => {
      // wrapping to a function is useful in case you want to access `window.google`
      // to eg. setup options or create latLng object, it won't be available otherwise
      // feel free to render directly if you don't need that

      function onLoad (mapInstance) {
        // do something with map Instance
        const bounds = new window.google.maps.LatLngBounds();

        cards.forEach(card => {
          if (card.card_type === 'place') {
            bounds.extend(new window.google.maps.LatLng(card.latitude, card.longitude));
          }
        });

        mapInstance.fitBounds(bounds);
      }

      return (
        <View
          style={{
            marginVertical: 6,
            height: 200,
            borderRadius: 20,
            overflow: 'hidden',
          }}
        >
          <Maps.GoogleMap
            mapContainerStyle={{width: '100%', height: '100%'}}
            options={{gestureHandling: 'none'}}
            zoom={10}
            onLoad={onLoad}
          >
            {cards.map(card => card.card_type === 'place' && (
              <Maps.Marker
                key={card.id}
                position={{lat: card.latitude, lng: card.longitude}}
                title={card.title}
              />
            ))}
          </Maps.GoogleMap>
        </View>
      );
    };

    if (loadError) {
      return <div>Map cannot be loaded right now, sorry.</div>;
    }

    return isLoaded ? renderMap() : <ActivityIndicator size="small" style={{marginVertical: 2}}/>;
  };
}

export default PlacesMap;
